'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface RelatedResource {
  id: number;
  title: string;
  type: string;
  image: string;
  alt: string;
  readTime: string;
}

interface RelatedResourcesSectionProps {
  resources: RelatedResource[];
  onResourceClick: (id: number) => void;
}

const RelatedResourcesSection = ({ resources, onResourceClick }: RelatedResourcesSectionProps) => {
  return (
    <div className="bg-muted/30 rounded-lg p-8">
      <div className="flex items-center space-x-3 mb-6">
        <Icon name="SparklesIcon" size={24} variant="solid" className="text-accent" />
        <h2 className="text-2xl font-bold font-headline text-foreground">
          Recommended For You
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {resources.map((resource) => (
          <button
            key={resource.id}
            onClick={() => onResourceClick(resource.id)}
            className="bg-card rounded-lg overflow-hidden shadow-card hover:shadow-modal transition-all duration-300 group text-left"
          >
            <div className="relative h-32 overflow-hidden">
              <AppImage
                src={resource.image}
                alt={resource.alt}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
              <span className="absolute bottom-3 left-3 text-xs font-semibold text-white bg-white/20 backdrop-blur-sm px-2 py-1 rounded">
                {resource.type}
              </span>
            </div>

            <div className="p-4">
              <h3 className="text-sm font-semibold font-headline text-foreground mb-2 line-clamp-2 group-hover:text-primary transition-colors duration-300">
                {resource.title}
              </h3>
              <div className="flex items-center justify-between">
                <span className="text-xs text-muted-foreground flex items-center space-x-1">
                  <Icon name="ClockIcon" size={12} variant="outline" />
                  <span>{resource.readTime}</span>
                </span>
                <Icon
                  name="ArrowRightIcon"
                  size={16}
                  variant="outline"
                  className="text-primary group-hover:translate-x-1 transition-transform duration-300"
                />
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default RelatedResourcesSection;